import React from 'react';
import CreditMiniView, { CreditMiniViewProps } from './CreditMiniView';
import { useLastCredit } from '../../../../features/Jouly/hooks';

export interface CreditMiniPresenterProps {
  deviceId?: string;
}

export default function CreditMiniPresenter({
  deviceId
}: CreditMiniPresenterProps) {
  const { creditValue, formattedCredit, creditStatus, creditTime, isLoading } = useLastCredit(deviceId);

  if (isLoading) {
    return <>...</>
  }

  const viewProps: CreditMiniViewProps = {
    creditValue,
    formattedCredit,
    creditStatus,
    deviceId,
    creditTime
  };

  return <CreditMiniView {...viewProps} />;
}

